export default __webpack_public_path__ + "static/media/sewing.70c56f73.png";